<template>
  <div class="row spinner-parent">
    <div class="col-12">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h1>Image Gallery</h1>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <strong>Manage Images</strong>
            <router-link
              class="btn btn-primary btn-sm pull-right"
              style="margin-left: 15px;"
              :to="{ name: 'GalleryAddImages', params: { id: $route.params.id }}"
            >
              Add new Images
            </router-link>
            <router-link
              class="btn btn-primary btn-sm pull-right"
              :to="{ name: 'GalleryEdit', params: { id: $route.params.id }}"
            >
              Back to General
            </router-link>
          </div>

          <div class="card-block">
            <input
              v-model="searchQuery"
              type="text"
              class="form-control"
              placeholder="Search by Image title"
            >
          </div>
          <div class="card-block spinner-parent">
            <spinner ref="spinner" size="md" text="Loading ..." />

            <div class="table-responsive">
              <table class="entities table table-bordered table-striped table-sm">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Thumbnail</th>
                    <th>Title</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody v-if="total">
                  <tr v-for="item in images" :key="item.id" :data-id="item.id">
                    <td class="table-list__cell--narrow">{{ item.id }}</td>
                    <td class="table-list__cell--narrow">
                      <img :src="item.thumbnail" :alt="item.title" style="max-height: 150px;">
                    </td>
                    <td>{{ item.title }}</td>
                    <td class="table-list__cell--narrow">
                      <router-link
                        class="btn btn-primary btn-sm"
                        :to="{ name: 'ImageEdit', params: { id: item.id }}"
                      >
                        Edit
                      </router-link>
                      <open-on-site
                        :source-route="item.route"
                      />
                      <button
                        class="btn btn-danger btn-sm"
                        @click="deleteImage(item)"
                      >
                        Delete
                        <span class="btn-loader" style="display: none;" />
                      </button>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="4" class="text-center">
                      There are no images yet. Go to 'Add new images' to add new ones.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <nav>
              <pager
                :total="total"
                :offset="offset"
                :size="perPage"
                @page-changed="changePage"
              />
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div><!--/.row-->
</template>

<script>
import _ from 'lodash';
import Pager from '@/global/components/Pager';
import OpenOnSiteButton from '@/global/components/OpenOnSiteButton';

export default {
  name: 'GalleryManageImages',

  components: {
    pager: Pager,
    'open-on-site': OpenOnSiteButton,
  },

  data() {
    return {
      searchQuery: '',
      searchProcessId: null,
      total: 0,
      offset: 0,
      perPage: null,
      images: [],
      saveErrorMessage: 'Error in data saving',
    };
  },

  watch: {
    searchQuery: _.debounce(function () {
      this.offset = 0;
      this.getImages();
    }, 400),
    offset() {
      this.getImages();
    },
  },

  mounted() {
    this.getImages();
  },

  methods: {
    getImages() {
      if (this.$refs.spinner) { this.$refs.spinner.show(); }
      const searchString = encodeURI(this.searchQuery);
      const page = this.perPage ? (this.offset / this.perPage + 1) : 1;
      const searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(`${this.$config.app_api.prefix}media/image-galleries/${this.$route.params.id}/images`, {
        params: {
          search_string: searchString,
          page,
        },
      }).then((response) => {
        if (this.searchProcessId === searchProcessId) {
          if (this.$refs.spinner) { this.$refs.spinner.hide(); }
          this.total = response.data.meta.pagination.total;
          this.perPage = response.data.meta.pagination.per_page;

          const imagesArr = _.cloneDeep(response.data);
          delete imagesArr.meta;
          this.images = imagesArr;
        }
      }).catch((error) => {
        if (this.$refs.spinner) { this.$refs.spinner.hide(); }
        console.error(error);
      });
    },
    deleteImage(image) {
      if (window.confirm(`Do you really want to detach Image ${image.title} with id = ${image.id}?`)) {
        const $btnDeleteLoader = $(`table.entities tr[data-id="${image.id}"] .btn-danger .btn-loader`);
        const postFormData = new FormData();
        $btnDeleteLoader.show();
        postFormData.append('ids[]', image.id);
        this.$apiHttp.post(
          `${this.$config.app_api.prefix}media/image-galleries/${this.$route.params.id}/detach/images`,
          postFormData,
        ).then(() => {
          console.log(`Image Galleries ${image.title} with ID = ${image.id} has detached`);
          $btnDeleteLoader.hide();
          this.getImages();
        }).catch((error) => {
          console.error('Error in detach image request', error);
          $btnDeleteLoader.hide();
        });
      }
    },
    changePage(offset) {
      this.offset = offset;
    },
  },
};
</script>



// WEBPACK FOOTER //
// ManageImages.vue?c5e09280